export const LOCATION_TYPES = Object.freeze({
  FARM: 'FINCA',
  OFFICE: 'OFICINA',
  ORIGIN: 'PROCEDENCIA',
  DESTINATION: 'DESTINO'
})

export const hasLocationType = (location, code) => {
  const codes = location?.typeCodes || (location?.types || []).map(type => type.code)
  return codes.includes(code)
}

export const locationsForType = (locations, code, selectedId = null) =>
  (locations || []).filter(location => location.id === selectedId || hasLocationType(location, code))
